/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,o){super(r,"vec2",2,(s,t,c,f)=>s.setUniform2fv(r,e(t,c,f),o))}}export{e as Float2DrawUniform};
